import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import { APPLICATION_JSON } from '../../middleware/types';
import Helper from '../Helper';
import { useDispatch, useSelector } from 'react-redux';
import { getShoppingListDetails } from '../../middleware/getShoppingListDetails';
import { updateShoppingListDetailsAction } from '../../middleware/updateShoppingListDetailsAction';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { addToListDetailsAction } from '../../middleware/addToListDetailsAction';

const AddShoppingListModal = (props) => {
    const[productId,setProductId,productIdRef]= useStateRef("");
    const [responseList, setResponseList, responseListRef] = useStateRef([])
    const [wishlistQty, setWishlistQty, wishlistQtyRef] = useStateRef();
    const [selectedProductIds, setSelectedProductIds, selectedProductIdsRef] = useStateRef([])
    const [addShoppingListResponse, setAddShoppingListResponse, addShoppingListResponseRef] = useStateRef("")
    const [validShoppingListResponse, setValidShoppingListResponse, validShoppingListResponseRef] = useStateRef("")
    const [invalidShoppingListResponse, setInvalidShoppingListResponse, invalidShoppingListResponseRef] = useStateRef("")
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [addNewList, setAddNewList, addNewListRef] = useStateRef(false);
    const shoppingListDetails = useSelector(state => state.getShoppingListDetails.listDetails)
    const dispatch = useDispatch();
    const history = useHistory();
    const formRef = useRef(null);
    const [orderIdState, setOrderIdState, orderIdStateRef] = useStateRef();
    const [isChecked, setIsChecked] = useState(false);
    const addToListDetails = useSelector(state => state.addToListDetails.product);

    useEffect(() => {
        console.log("productttt Id...",props.productId);
        if (props.commerceId || props.productId) {
            if (shoppingListDetails) {
                setResponseList(shoppingListDetails)
            }
        }
        // if (props?.productId) {
        //     setProductId(props?.productId)
        // }
        if(addToListDetails){
            setProductId(addToListDetails)
        }
        else if(props?.productId) {
            setProductId(props?.productId)
        }
        if (props.orderId) {
            setOrderIdState(props.orderId)
        }
        if (props.quantity) {
            setWishlistQty(props.quantity.toString())
        }
        formRef.current && formRef.current.reset();
        document.querySelector('#newListModalww').addEventListener('hidden.bs.modal', function (e) {
          
            var selected = [];
            var tables = document.getElementById("listList");
            var chks = tables.getElementsByClassName("checkInputOne");
            for (var i = 0; i < chks?.length; i++) {
                if (chks[i].checked) {
                    chks[i].checked = false;
                }
            }
            formRef.current && formRef.current.reset();
        if(document.getElementById("eventName") ){
            document.getElementById("eventName").innerHTML ="";
        }
        if(document.getElementById("newDescription")){
            document.getElementById("newDescription").innerHTML ="";
        }

        })
    }, [props])

    useEffect(()=>{
        if(addToListDetails || props?.productId){
            addToListDetails ? setProductId(addToListDetails) : props?.productId ? setProductId(props?.productId) : '';
        }
        console.log('setted ...',productIdRef.current);
        if (document.querySelector('#newListModalww')) {
			document.querySelector('#newListModalww').addEventListener('hidden.bs.modal', function (e) {
                dispatch(addToListDetailsAction(''));
			})
		}
    },[])

    const handleIndividualChecked = (event) => {
        var selected = [];
        var tables = document.getElementById("listList");
        var chks = tables.getElementsByClassName("checkInputOne");
        for (var i = 0; i < chks.length; i++) {
            if (chks[i].checked) {
                selected.push(chks[i].id);
            }
        }
        setSelectedProductIds(selected);
    };

    const validateCreateListForm = (key, value) => {

        switch (key) {
            case "eventName":
                var validation = /[!#$%"&|{}~`]/;
                var regex = RegExp(validation);
                var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    document.getElementById("errMsgAlert").classList.remove("d-none")
                    document.getElementById("errMsgAlert").classList.add("d-block")
                    document.getElementById("eventName").classList.add("form-error")
                    document.getElementById("errMsgAlert").innerHTML = "List Name is a required field. Special characters cannot be used.";
                } else if (regex.test(value)) {
                    setHasError(true)
                    document.getElementById("errMsgAlert").classList.remove("d-none")
                    document.getElementById("errMsgAlert").classList.add("d-block")
                    document.getElementById("eventName").classList.add("form-error")
                    document.getElementById("errMsgAlert").innerHTML = "List Name should not contain special characters.";
                } else {
                    document.getElementById("errMsgAlert").innerHTML = "";
                    document.getElementById("errMsgAlert").classList.remove("d-block")
                    document.getElementById("errMsgAlert").classList.add("d-none")
                    document.getElementById("eventName").classList.remove("form-error")
                }
                break;

            default:
        }
    }

    const clearErrMsg = () => {
        setHasError(false);
        setAddNewList(false);
        document.getElementById("errMsgAlert").innerHTML = "";
        document.getElementById("errMsgAlert").classList.remove("d-block")
        document.getElementById("errMsgAlert").classList.add("d-none")
        document.getElementById("eventName").classList.remove("form-error")
    }

    const handleCreateShoppingList = async (event) => {
        event.preventDefault();
        clearErrMsg();
        var formData = new FormData(event.target);
        // var check = formData.get("check");
        var check = document.getElementById("new-list").checked;
        var selected = [];
        var tables = document.getElementById("listList");
        var chks = tables.getElementsByClassName("checkInputOne");
        for (var i = 0; i < chks.length; i++) {
            if (chks[i].checked) {
                selected.push(chks[i].id);
            }
        }
        var selectedLists = selected;
        if (check) {
            setAddNewList(true);
        } else {
            setAddNewList(false);
            if(selectedLists.includes('new-list')){
                selectedLists = selectedLists.filter(listName => listName !== "new-list")
            }
        }

        if (selectedLists.length === 0 && !addNewListRef.current) {
            selectedLists = []
        }else if(addNewListRef.current){
            if (!selectedLists.includes("new-list")) {
            selectedLists.push("new-list");
            }
        }
        let checkbox = "";
        if((selectedLists.length > 0 && !selectedLists.includes('new-list') )&& formData.get("eventName")){
            checkbox ="";
        }else if((selectedLists.length == 0 && !selectedLists.includes('new-list') )&& formData.get("eventName")){
            checkbox = "false";
        }else if(addNewListRef.current){
            checkbox = "true";
        }else{
            checkbox = "";
        }
      
        if (!hasErrorRef.current) {
            var eventName = ""
            var newDescription = ""
             if (addNewListRef.current) {
            eventName = formData.get("eventName");
            newDescription = formData.get("newDescription");
             }

            let inputMap;
            if (orderIdStateRef.current) {
                inputMap = {
                    items: "",
                    listOrderId: orderIdStateRef.current,
                    eventName: eventName,
                    description: newDescription,
                    quantities: wishlistQtyRef.current ? wishlistQtyRef.current : "1",
                    selectedLists: selectedLists.join(","),
                    citems: props.commerceId ? props.commerceId : "",
                    checkBox: checkbox
                }

            }
            else {
                inputMap = {
                    items: productIdRef.current?? props?.productId ?? "",
                    eventName: eventName,
                    description: newDescription,
                    quantities: wishlistQtyRef.current ? wishlistQtyRef.current : "1",
                    selectedLists: selectedLists.join(","),
                    citems: props.commerceId ? props.commerceId : "",
                    checkBox: checkbox
                }

            }



            var actionUrl = "api/rest/cb/shopping-list/add-product-to-shopping-list";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
            if (res.result == "success") {
                //location.reload()
                var shoppingListSuccessDetatils = (JSON.parse(res.response)).response.response
                setAddShoppingListResponse(shoppingListSuccessDetatils)
                setValidShoppingListResponse(shoppingListSuccessDetatils.validproducts)
                setInvalidShoppingListResponse(shoppingListSuccessDetatils.invalidProducts)
                dispatch(updateShoppingListDetailsAction(true));
                document.getElementById("add-shopping-list-modal-close").click();
                formRef.current.reset();
                // dispatch(getShoppingListDetails); document.getElementById("newListModalww").click()
                var hiddenShoppingListSuccessModal = document.getElementById("hiddenShoppingListSuccessModal");
                hiddenShoppingListSuccessModal.classList.add("d-block");
                hiddenShoppingListSuccessModal.click()
                hiddenShoppingListSuccessModal.classList.remove("d-block");
                document.getElementById("errMsgAlert").innerHTML = "";
                document.getElementById("errMsgAlert").classList.add("d-none");
                setSelectedProductIds([]);
            } else {
                // setIsLoading(false)

                document.getElementById("errMsgAlert").classList.remove("d-none");
                document.getElementById("errMsgAlert").classList.add("d-block")
                var result = JSON.parse(res.errorMessage)

                result && Object.entries(result).map((error) => {
                    error.map((err) => (
                        <>
                            {document.getElementById("errMsgAlert").innerHTML = err.message}
                        </>
                    ))
                    document.getElementById("errMsgAlert").scrollIntoView({ behavior: 'smooth' });
                });

            }
           
        }
    }

    return (
        <>
            <div className="modal gx-0 fade c-modal c-shopping-list-modal-body" id="newListModalww" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md modal-lg-a">
                    <div className="modal-content">
                        <button type="button" className="btn-close d-flex justify-content-end" data-bs-dismiss="modal" aria-label="Close" id="add-shopping-list-modal-close"></button>
                        <div className="modal-body">
                            {/* <div class="alert alert-danger d-none text-start" role="alert" id="new-list-error"></div> */}

                            {/* <div className="col-12 plp-text-align-left">
                                <h3 className="modal-title" id="defaultModalLabel">
                                    Add to List
                                </h3>
                                <p>
                                    Save this item for later by adding it to a shopping list.
                                </p>
                            </div>
                            <div class="alert alert-danger d-none" id="errMsgAlert" role="alert">
                            </div>
                            <form onSubmit={handleCreateShoppingList} method="post" action="/" id="find-friend" className="col-12 form" data-hs-cf-bound="true" ref={formRef}>
                                <ul class="c-shop-list list-account list-wishlist" id="listList">
                                    {shoppingListDetails && shoppingListDetails.giftLists ? shoppingListDetails.giftLists.map((item) => {
                                        return (<>
                                            <li className="c-shop-list-item c-shop-list-body" id="removeShoppingList">
                                                <div className="c-list-left">
                                                    <span className="c-shop-list-content c-shop-list-check">
                                                        <input type="checkbox" onChange={handleIndividualChecked} className="form-check-input" name={`${item.giftListId}`} id={`${item.giftListId}`} />
                                                    </span>
                                                    <span className="row c-shop-list-content c-shop-list-name">
                                                        <label className="text-primary fw-bold col-6">{item.eventName}</label>
                                                        <label className="text-primary fw-bold col-6">Created {item.comments}</label>
                                                        <label className="text-primary fw-bold col-12">{item.Description}</label>
                                                    </span>
                                                </div>
                                            </li>
                                        </>)
                                    }) : ""}
                                </ul>

                                <div className="container-fluid list-modal-body">
                                    <div className="row plp-text-align-left">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" name="check" id="new-list" />
                                            <label class="row form-check-label" for="new-list">
                                                <span class="col-12 list-title">Add a New List</span>
                                            </label>
                                        </div>
                                        <div class="row mb-3 align-items-center">
                                            <label for="eventName" class="col-3 col-md-3 col-form-label">List Name:</label>
                                            <div class="col-9 col-md-7">
                                                <input type="text" maxlength="40" class="form-control" name="eventName" id="eventName" />
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <label for="newDescription" class="col-3 col-md-3  col-form-label">List Description:</label>
                                            <div class="col-9 col-md-7">
                                                <textarea class="form-control" maxlength="120" name="newDescription" id="newDescription" rows="3"></textarea>
                                            </div>
                                        </div>

                                        <div className="row justify-content-end form-submit">
                                            <div className="col-auto">
                                                <input type="submit" className="col-auto btn add-cart-modal-button btn-primary" value="Save Item" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form> */}
                            <div class="container-fluid addToList-modal-body">
                                <div class="row align-items-center">
                                    <form onSubmit={handleCreateShoppingList} ref={formRef}>
                                        <div class="col-auto add-shopping-list-modal">
                                            <p class="modal-title h1-font-css" id="defaultModalLabel">Add to List</p>
                                            <p class="modal-subheading">Save this item for later by adding it to a shopping list.</p>
                                        </div>
                                        <div class="alert alert-danger d-none" id="errMsgAlert" role="alert"></div>
                                        {/* <div class="message message-red" style="display: none" id="add-error"></div> */}
                                        <ul class="col-12 list-unstyled addToList-items" id="listList">
                                            {shoppingListDetails && shoppingListDetails.giftLists ? shoppingListDetails.giftLists.map((item) => (
                                                <li class="addToList-item">
                                                    <div class="d-flex checkbox-input">
                                                        <input class="form-check-input checkInputOne me-2" type="checkbox" name={`${item.giftListId}`} id={`${item.giftListId}`} onChange={handleIndividualChecked} />
                                                        <span class=" checkbox-text" >
                                                            <label class="row form-check-label" for={`${item.giftListId}`}>
                                                                <span class="col-6 list-title">{item.eventName}</span>
                                                                <span class="col-6 list-date text-end">Created {item.comments}</span>
                                                                <span class="col-12 list-desc">{item.Description}</span>
                                                            </label>
                                                        </span>
                                                    </div>

                                                </li>)) : ""}
                                            <li class="addToList-item">
                                                <div class="form-check">
                                                    <input class="form-check-input checkInputOne" type="checkbox" name="check" id="new-list" />
                                                    <label class="row form-check-label" for="new-list">
                                                        <span class="col-12 list-title">Add a New List</span>
                                                    </label>
                                                </div>
                                                <div class="form">
                                                    <div class="row mb-3 align-items-center">
                                                        <label for="eventName" class="col-3 col-md-3 col-form-label">List Name:</label>
                                                        <div class="col-9 col-md-7">
                                                            <input type="text" maxlength="40" class="form-control" id="eventName" name='eventName' />
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <label for="newDescription" class="col-3 col-md-3  col-form-label">List Description:</label>
                                                        <div class="col-9 col-md-7">
                                                            <textarea class="form-control" maxlength="120" id="newDescription" name='newDescription' rows="3"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div class="row justify-content-end form-submit">
                                            <div class="col-auto">
                                                <input type="submit" class="col-auto btn btn-primary" value="Save Item" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Link to="#" className="d-none" id="hiddenShoppingListSuccessModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#shoppingListSuccess"></Link>
            <div className="modal gx-0 fade c-shopping-list-modal-body" id="shoppingListSuccess" tabindex="-1" aria-labelledby="shoppingListSuccess" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md modal-lg-a">
                    <div className="modal-content">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div class="col-12 text-start">
                                <h3 class="modal-title" id="defaultModalLabel">Added to List</h3>
                            </div>
                            <div class="col-12 mb-3 text-end d-none d-md-block">
                                <button class="btn btn-primary mx-1" data-bs-dismiss="modal">Continue Shopping</button>
                                <button class="btn btn-primary" data-bs-dismiss="modal" onClick={() => history.push("/account/list")}>Go to Shopping Lists</button>
                            </div>
                            <ul class="col-12 list-unstyled addedToList-items">
                                <div class="alert alert-success my-0 d-block" role="alert">
                                    <p class="fwb">The following products were added to your list(s):</p>
                                </div>
                               
                                {validShoppingListResponseRef.current && validShoppingListResponseRef.current.map((value) => {
                                    return (<>
                                        <li class="addToList-item">
                                            <div class="row">
                                                <div class="col-10 col-md-2 list-sku">Item #&nbsp;{value.ProductId ? value.ProductId : ""}</div>
                                                <div class="col-10 order-3 order-md-2 col-md-8 list-title" dangerouslySetInnerHTML={{ __html: value.productName ? value.productName : "" }}></div>
                                                <div class="col-2 order-2 order-md-3 item-qty text-center">Qty:&nbsp;{value.Quantity ? value.Quantity : ""}</div>
                                            </div>
                                        </li>
                                    </>)
                                })}
                            </ul>
                            
                            {invalidShoppingListResponseRef.current && invalidShoppingListResponseRef.current.length > 0 ?
                                <>
                                    <div class="alert message message-red d-block" role="alert">
                                        <p class="fwb">We were unable to add the following items to your list(s):</p>
                                    </div>
                                    <ul class="col-12 list-unstyled addedToList-items">
                                        {invalidShoppingListResponseRef.current ? invalidShoppingListResponseRef.current.map((value) => {
                                            return (<>
                                                <li class="addToList-item">
                                                    <div class="row">
                                                        <div class="col-10 col-md-2 list-sku">Item #&nbsp;{value.ProductId ? value.ProductId : ""}</div>
                                                        <div class="col-10 order-3 order-md-2 col-md-8 list-title" dangerouslySetInnerHTML={{ __html: value.productName ? value.productName : "" }}></div>

                                                    </div>
                                                </li>
                                            </>)
                                        }) : ""}
                                    </ul>
                                </>
                                : ""}



                            <div class="col-12 mb-3 text-end">
                                <button class="btn btn-primary mx-1" data-bs-dismiss="modal">Continue Shopping</button>
                                <button class="btn btn-primary" data-bs-dismiss="modal" onClick={() => history.push("/account/list")} >Go to Shopping Lists</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddShoppingListModal

